import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CoachCheckoutPage } from 'pages/coach-checkout/coach-checkout-page';

@NgModule({
  declarations: [CoachCheckoutPage],
  imports: [PagesModule, ComponentsModule],
  exports: [CoachCheckoutPage],
})
export class CoachCheckoutPageModule {}
